import { createSlice } from '@reduxjs/toolkit';

export const userDetailsSlice = createSlice({
  name: 'userDetailsResponse',
  initialState: {
    userDetails: undefined,
    isSSOIntegrated: undefined
  },
  reducers: {
    setUserDetails: (state, action) => {
      const { userDetails, isSSOIntegrated } = action.payload;
      state.userDetails = userDetails;
      state.isSSOIntegrated = isSSOIntegrated;
    },
  },
});

export const { setUserDetails } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;